<template>
    <section class="square-banners">
        <div
            v-for="(item, index) in list"
            :key="`${item.title}-${index}`"
            class="square-banners__item-wrapper"
        >
            <ItemSquareBanners
                v-bind="item"
            />
        </div>
    </section>
</template>

<script>
import ItemSquareBanners from './components/ItemSquareBanners';

export default {
    name: 'SquareBanners',
    components: { ItemSquareBanners },
    props: {
        list: {
            type: Array,
            required: true,
        },
    },
};
</script>

<style lang="scss">
    @mixin getIframeSize($sourceMap) {
        height:calc(
            #{map-get($sourceMap, margins)+ px}
            + #{map-get($sourceMap, imageHeight)+ px}
            + #{map-get($sourceMap, titleHeight)+ px}
            + (#{map-get($sourceMap, lines) * map-get($sourceMap, lineHeight)})
            );
    }

    $desktop: (
        lines: 3,
        titleHeight: 16,
        lineHeight: 16px,
        imageHeight: 398,
        margins: 50,
    );

    $tablet: (
        lines: 4,
        titleHeight: 16,
        lineHeight: 16px,
        imageHeight: 322,
        margins: 50,
    );

    $mobile: (
        lines: 5,
        titleHeight: 18,
        lineHeight: 8vw,
        imageHeight: 185,
        margins: 50,
    );

    .square-banners {
        display: flex;
        width: calc(100%);
        padding: 15px 0 25px 0;
        margin: 0;
        flex-wrap: wrap;
        min-height: 521px;
        justify-content: space-between;

        &__item {
            width: 100%;
        }

        &__item-wrapper {
            flex: 0 1 calc(50%);
            margin: 0;
            overflow: hidden;

            > .double-click > div {
                width: 100% !important;
            }

            .square-banners__item {
                max-width: 548px;
            }
        }

        &__image-wrapper {
            height: 398px;
        }

        iframe {
            @include getIframeSize($desktop);
        }
    }

    @media (min-width: $breakpoint-big-desktop) {
        .square-banners {
            width: 100%;
            max-width: 1144px;

            &__item-wrapper {
                &:nth-child(odd) {
                    iframe, .square-banners__item {
                        max-width: 548px;
                        float: left;
                    }
                }

                &:nth-child(even) {
                    iframe, .square-banners__item {
                        max-width: 548px;
                        float: right;
                    }
                }
            }
        }
    }

    @media (max-width: $breakpoint-big-desktop) {
        .square-banners {
            min-height: 370px;

            &__item-wrapper {
                flex: 0 1 calc(50% - 10px);
                margin: 0;
            }

            .square-banners__image-wrapper {
                height: 247px;
            }
        }
    }

    @media (max-width: $breakpoint-small-desktop) {
        .square-banners {
            min-height: 370px;

            .square-banners__image-wrapper {
                min-height: 185px;
                height: auto;
            }

            iframe {
                @include getIframeSize($tablet);
            }
        }
    }

    @media (max-width: $breakpoint-tablet) {
        .square-banners {
            width: 100%;
            margin: 0;
            padding-bottom: 0;
            padding-top: 0;

            &__item-wrapper {
                flex: 0 0 100%;
                margin: 40px 0 0 0;
            }

            iframe {
                @include getIframeSize($mobile);
            }
        }
    }
</style>
